// extracted by mini-css-extract-plugin
module.exports = {"normal":"styles_normal__2siZ3","opened":"styles_opened__3yRUJ styles_normal__2siZ3"};